import axios from 'api/axios-configure'
import { TableReport } from 'components/TableReport'
import format from 'date-fns/format'
import { Button, Search, useKeyEvent, Icon, Tooltip  } from 'monday-ui-react-core'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Row } from 'react-bootstrap'
import { GraphUp } from 'react-bootstrap-icons'
import { useSearchParams } from 'react-router-dom'
import pdfIcon from './../../assest/images/pdf-icon.svg'
import { toast } from 'react-toastify'
import { StatementContext } from 'utils/context/StatementsContext'
import { getRowSelectionBaseKey } from 'utils/commonUtils'

export default function PayoutOverview ({ type, setAnalysisPayoutFilters }) {
    const { getPayoutStatementPDF } = useContext(StatementContext)
    const [searchParams] = useSearchParams()
    const [isLoading, setIsLoading] = useState(false)
    const [isFetching, setIsFetching] = useState(false)
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25, //customize the default page size
    })
    const [columnVisibility, setColumnVisibility] = useState({})
    const [rowCount, setRowCount] = useState(0)
    const [sorting, setSorting] = useState([])
    const [tableData, setTableData] = useState([])
    const [hasMassDownload, setHasMassDownload] = useState(type === 'sender')
    const [searchInput, setSearchInput] = useState('')
    const [isSearchFocused, setIsSearchFocused] = useState(false)
    const isRendered = useRef(false)

    useKeyEvent({
        keys: ["Enter"],
        // @ts-ignore
        callback: e => onEnterPressed(e.key)
    });

    const onEnterPressed = (keyName) => {
        if(keyName === 'Enter' && isSearchFocused){
            handleSearchSubmit()
            setIsSearchFocused(true)
        }
    }

    const showDownloadToast = (fileType) => {
        toast.success(`Downloading ${fileType}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const onDownloadButtonClicked = (rows, selectedRadio) => {
        const selectedRows = Object.keys(rows)
        const postData = selectedRows.map(row => {
            const splittedKey = getRowSelectionBaseKey(row).split(',')
            return {
                documentSystemNumber: splittedKey[0],
                runId: splittedKey[1],
                ownerName: splittedKey[2] ?? ''
            }
        })
        showDownloadToast("PDF")
        getPayoutStatementPDF(postData, type)        
    }

    const handlePdfIconClick = (row) => {
        showDownloadToast("PDF")
        const { documenT_SYSTEM_NUMBER, runId } = row
        const postData = []
        const data = {
            documentSystemNumber: documenT_SYSTEM_NUMBER,
            ownerName: "",
            runId
        }
        postData.push(data)

        if (postData.length) {
            getPayoutStatementPDF(postData, type)
        }
    }

    const handleSearchSubmit = () => {
        setPagination({pageIndex: 0, pageSize: pagination.pageSize})
        const payoutAdvancedSearch = getAdvancedSearchValues()
        GetSenderPayoutOverviewPaginated(payoutAdvancedSearch)
    }

    const handleSearchChange = (value) => {
        setSearchInput(value.trim())
    }

    const getAdvancedSearchValues = () => {
        const searchParamsObj = Object.fromEntries([...searchParams])
        const { senderNumber } = searchParamsObj

        const payoutAdvancedSearch = {
            globalSearch: searchInput,
            pageNumber: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            sortDesc: sorting[0]?.desc,
            SortBy: sorting[0]?.id,
            senderNumber
        }

        return payoutAdvancedSearch
    }

    const handleAnalysisIconClick = (payoutId, runId, documentNumber, statementType) => {
        const searchParamsObj = Object.fromEntries([...searchParams])
        const { senderNumber } = searchParamsObj

        setAnalysisPayoutFilters({
            senderNumber: senderNumber,
            runId: runId,
            documentNumber: documentNumber,
            statementType: statementType,
            pageNumber: 1,
            pageSize: 25
        })
    }

    const GetSenderPayoutOverviewPaginated = (payoutAdvancedSearch) => {
        var data = {}
        let url = ''
        data = payoutAdvancedSearch
        if (type === 'sender') {
            url = '/GetSenderPayoutOverviewPaginated'
        }
        else {
            url = '/GetReceiverOverviewPaginated'
        }

        if (!tableData.length)
            setIsLoading(true)
        else
            setIsFetching(true)

        setIsFetching(true)
        axios
            .post(url, data)
            .then((response) => {
                setTableData(response.data.items)
                setRowCount(response.data.totalCount)
                if (response.data.hasPDFMassDownload != null) {
                    setHasMassDownload(response.data.hasPDFMassDownload)
                }
            })
            .catch(() => {
                setIsFetching(false) //TODO: Validate how to handle BE BadRequest response
                setIsLoading(false)
            })
            .finally(() => {
                setIsFetching(false)
                setIsLoading(false)
            })
    }

    // useEffect(() => {
    //     if (isRendered.current) {
    //         const payoutAdvancedSearch = getAdvancedSearchValues()
    //         GetSenderPayoutOverviewPaginated(payoutAdvancedSearch)
    //     }
    // }, [sorting])

    useEffect(() => {
        if (isRendered.current) {
            setColumnVisibility(columnVisibility);
        }
      }, [columnVisibility]);

    // useEffect(() => {
    //     const payoutAdvancedSearch = getAdvancedSearchValues()
    //     GetSenderPayoutOverviewPaginated(payoutAdvancedSearch)  
    //     isRendered.current = true     
    // }, [pagination.pageIndex, pagination.pageSize])

    const senderColumns = useMemo(
        () => [
            {
                header: 'Actions',
                size: 60,
                enableSorting: false,
                maxSize: 60,
                Cell: ({ row }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() => handlePdfIconClick(row.original)}
                                />
                            </Tooltip>
                            <Tooltip content="View Analysis">
                                <GraphUp
                                    className="payout-icon"
                                    size={15}
                                    onClick={() => handleAnalysisIconClick(row.original.payoutId, row.original.runId, row.original.documenT_SYSTEM_NUMBER, row.original.statementType)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
            },
            {
                accessorKey: 'sender',
                size: 280,
                maxSize: 280,
                header: (
                    <>
                        <div title='Sender Name'>
                            <div className="fw-bold header-container">Sender</div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'payoutId',
                size: 100,
                maxSize: 100,
                header: (
                    <>
                        <div title='Payout Id'>
                            <div className="fw-bold header-container">Payout</div>
                            <div className="fw-bold header-container">Id</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'payoutName',
                size: 280,
                maxSize: 280,
                header: (
                    <>
                        <div title='Payout Name'>
                            <div className="fw-bold header-container">Payout</div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'reportingMonth',
                size: 80,
                maxSize: 80,
                header: (
                    <>
                        <div title='Reporting Month'>
                            <div className="fw-bold header-container">Reporting</div>
                            <div className="fw-bold header-container">
                                Month
                            </div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, 'MM/dd/yyyy')
                    return <>{result}</>
                }
            },
            {
                accessorKey: 'status',
                size: 50,
                maxSize: 50,
                header: (
                    <>
                        <div title='Status'>
                            <div className="fw-bold header-container">Status</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'poBalance',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                size: 100,
                maxSize: 100,
                header: (
                    <>
                        <div title='Payout Balance'>
                            <div className="fw-bold header-container">Payout</div>
                            <div className="fw-bold header-container">Balance</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'deltaPercentage',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                size: 100,
                maxSize: 100,
                header: (
                    <>
                        <div title='Percent Change'>
                            <div className="fw-bold header-container">
                                Percent <br/> Change
                            </div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'avgChange',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                size: 100,
                maxSize: 100,
                header: (
                    <>
                        <div title='Average Monthly Change'>
                            <div className="fw-bold header-container">
                                Average Monthly
                            </div>
                            <div className="fw-bold header-container">
                                Change
                            </div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'estPOMonths',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                size: 80,
                maxSize: 80,
                header: (
                    <>
                        <div title='Est Months To Payout'>
                            <div className="fw-bold header-container">Est Months</div>
                            <div className="fw-bold header-container">To Payout</div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const months = cell.getValue()
                    const result = months < 999999 ? months : '-'
                    return <>{result}</>
                }
            },
            {
                accessorKey: 'estPODate',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                size: 80,
                maxSize: 80,
                header: (
                    <>
                        <div title='Est Payout Date'>
                            <div className="fw-bold header-container">Est Payout</div>
                            <div className="fw-bold header-container">Date</div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = date < new Date(9998, 12, 31) ? dateString : '-'
                    return <>{result}</>
                }
            },
        ],
        []
    )

    const receiverColumns = useMemo(() => [], [])

    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
  
    //table state
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');

    useEffect(() => {
        const payoutAdvancedSearch = getAdvancedSearchValues()
        GetSenderPayoutOverviewPaginated(payoutAdvancedSearch)  
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [
        columnFilters,
        globalFilter,
        pagination.pageIndex,
        pagination.pageSize,
        sorting,
      ]);

    return (
        <Row>
            {/*We might want to move this up, for now we will leave it on the table*/}
            <section className="statements-container mt-2 mb-5">
                <div
                    style={{
                        width: '30%',
                    }}
                    className="d-flex my-2"
                >
                    <Search
                        placeholder="Search"
                        size={Search.sizes.SMALL}
                        onChange={handleSearchChange}
                        onFocus={() => setIsSearchFocused(true)}
                        onBlur={() => setIsSearchFocused(false)}
                        className="payout-search"
                    />
                    <Button
                        size={Button.sizes.SMALL}
                        type={Button.types.SUBMIT}
                        onClick={handleSearchSubmit}
                        className="payout-search-button"
                    >
                        Search
                    </Button>
                </div>

                <div className="table-wrapper">
                    
                    <TableReport
                        enableManualSorting={true}
                        setColumnVisibility={setColumnVisibility}
                        onPaginationChange={setPagination}
                        pagination={pagination}
                        sorting={sorting}
                        onSortingChange={setSorting}
                        enableRowSelection={true}
                        hasMassDownload={hasMassDownload}
                        rowCount={rowCount}
                        columnVisibility={columnVisibility}
                        columns={
                            senderColumns
                        }
                        tableData={tableData}
                        onDownloadButtonClicked={onDownloadButtonClicked}
                        isLoading={isLoading}
                        isFetching={isFetching}
                        setRowSelection={setRowSelection}
                        rowSelection={rowSelection}
                        rowId={(row) => { 
                            if(tableData.length > 0)
                                return (row.documenT_SYSTEM_NUMBER ?? '') + ',' + (row.runId ?? '') + ',' + (row.ownerName1 ?? '') + ',' + (row.hasDownloadFile)
                        }}
                        isPayout={true}
                    />
 
            </div>

            </section>
        </Row>
    )
}
